import { render, staticRenderFns } from "./Banned.vue?vue&type=template&id=8ac34e42&scoped=true&lang=true&"
import script from "./Banned.vue?vue&type=script&lang=js&"
export * from "./Banned.vue?vue&type=script&lang=js&"
import style0 from "./Banned.vue?vue&type=style&index=0&id=8ac34e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac34e42",
  null
  
)

export default component.exports